import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import FlipCard from "./FlipCard";

/**
 * Reference card overlay with h4 group titles (Tembo Teenpatti 1-day, Worli Matka):
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > (h4.text-left.text-white.text-uppercase + div > <span><img></span> …) per group
 * Always rendered once the round has cards; like the reference it is hidden (.hide-cards) while the
 * first card is a back ("1"), and the shuffle handle toggles it otherwise.
 * groups: [{ title, idx: [card indexes] }]
 */
export default function RefPlayerCardsOverlay({ card, groups }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null || card === "") return null;
  const cards = String(card).split(",").map((c) => c.trim());
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {groups.map((g, gi) => (
          <React.Fragment key={g.title}>
            {gi > 0 && " "}
            <h4 className="text-left text-white text-uppercase">{g.title}</h4>{" "}
            <div>
              {g.idx.map((ci, i) => (
                <React.Fragment key={ci}>
                  {i > 0 && " "}
                  <span>
                    <FlipCard src={getCardImage(cards[ci] ?? "1")} alt="" />
                  </span>
                </React.Fragment>
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
